import React from 'react';
import styles from './PageSidebar.scss';

const PageSidebar: React.StatelessComponent = ({ children }) => (
  <div className={styles.sidebar}>{children}</div>
);

export default PageSidebar;



// WEBPACK FOOTER //
// ./src/components/Page/PageSidebar/PageSidebar.tsx